import React, { useEffect, useState } from 'react';
import { api } from "../../api";
import EditModal from './EditModal';
import { formatDate } from '../../utils/formatDate';
import AddForm from './AddForm';

function VehicleList({ reloadFlag }) {
  const [vehicles, setVehicles] = useState([]);
  const [selected, setSelected] = useState(null);
  const fetchVehicles = async () => {
    try {
      const res = await api.get('/vehicles');
      setVehicles(res.data);
    } catch (err) {
      console.error('Fel vid hämtning av fordon:', err);
    }
  };
  useEffect(() => {
    fetchVehicles();
  }, [reloadFlag]);

  return (
    <div className="container mt-4">
      <h2>Fordonsbesiktning</h2>
      <div className="container-fluid px-2 px-md-3 py-2 mb-5">
        <AddForm onUpdate={fetchVehicles} activeTab="vehicles" />
      </div>
      <ul className="list-group">
        {vehicles.map(vehicle => (
            <li
                key={vehicle._id}
                className="list-group-item list-group-item-action py-3"
                onClick={() => setSelected(vehicle)}
                role="button"
            >
                <div className="fw-bold">{vehicle.regNr}</div>
                <div className="small text-muted">
                <strong>Senaste besiktning:</strong> {formatDate(vehicle.inspectionDate)}
                </div>
                <div className="small text-muted">
                <strong>Nästa besiktning:</strong> {formatDate(vehicle.inspectionExpires)}
                </div>
            </li>
        ))}
      </ul>

      {selected && (
        <EditModal
          type="vehicle"
          item={selected}
          onClose={() => setSelected(null)}
          onUpdate={fetchVehicles}
        />
      )}
    </div>
  );
}

export default VehicleList;
